module.exports = __webpack_public_path__ + "media/branton-poster.4e803282.mp4";